export default __webpack_public_path__ + "static/media/facebook-white-18dp.d76d31fc.svg";